module.exports = __webpack_public_path__ + "img/soul-groove.c414d62f.png";